"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPickedColorNow = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importStar(require("react"));
var colorConfig_1 = require("./colorConfig");
var ColorItem_1 = require("./ColorItem");
var makeMaterialUIColors_1 = __importDefault(require("./makeMaterialUIColors"));
exports.getPickedColorNow = function (_a) {
    var colorsArr = _a.colorsArr, colorIndex = _a.colorIndex, colorShade = _a.colorShade;
    return typeof colorIndex === 'number' && colorsArr.length > 0 ?
        colorsArr[colorIndex][colorShade] : '';
};
var useStyles = core_1.makeStyles(function (theme) { return ({
    root: {
        width: colorConfig_1.PICKER_TOOL_WIDTH,
    }
}); });
var ColorPickerTool = function (_a) {
    var colorShade = _a.colorShade, pickedColorIndex = _a.pickedColorIndex, pickFn = _a.pickFn;
    var classes = useStyles();
    var handlePick = react_1.useCallback(function (i, itemColor) {
        return function () { return pickFn(i, itemColor)(); };
    }, [pickFn]);
    return (react_1.default.createElement(core_1.Box, { className: classes.root, display: 'flex', flexWrap: 'wrap' }, makeMaterialUIColors_1.default.map(function (color, i) {
        var itemColor = color[colorShade];
        var isPicked = i === pickedColorIndex;
        return (react_1.default.createElement(ColorItem_1.ColorItem, { key: i, color: itemColor, isPicked: isPicked, onClick: handlePick(i, itemColor) }));
    })));
};
exports.default = ColorPickerTool;
